export default {
    Out_of_Bounds: "Состояние выхода за границы",
    existInfo: "Информация о наличии",
    sportsInfo: "Информация о движении",
    heartRate: "Показатель пульса",
    breatheInfo: "Информация о дыхании",
    breatheNum: "Показатель дыхания",
    In_and_out_of_bed: "Состояние в кровати/вне кровати",
    sleepState: "Состояние сна",
    soberDuration: "Длительность бодрствования",
    lightSleepDuration: "Длительность поверхностного сна",
    deepSleepDuration: "Длительность глубокого сна",
    SleepQualityRating: "Оценка качества сна",
    parahypnosis: "Нарушение сна",
    AbnormalStruggleState: "Состояние аномальной борьбы",
    none: "Нет",
    outsideTheRange: "Вне диапазона",
    WithinTheRange: "В диапазоне",
    unmanned: "Нет человека",
    someone: "Есть человек",
    static: "Неподвижно",
    active: "Активно",
    normal: "Норма",
    hyperapnea: "Учащённое дыхание",
    hypopnea: "Замедленное дыхание",
    leaveTheBed: "Встал с кровати",
    getIntoBed: "Лёг в кровать",
    deepSleep: "Глубокий сон",
    lightSleep: "Поверхностный сон",
    sober: "Бодрствует",
    minute: "минут",
    GoodSleepQuality: "Качество сна хорошее",
    AverageSleepQuality: "Качество сна среднее",
    PoorSleepQuality: "Качество сна низкое",
    SleepLessThanHours: "Длительность сна менее 4 часов",
    SleepLongerThanHours: "Длительность сна более 12 часов",
    longTimeNoOne: "Длительное отсутствие человека",
    normalState: "Нормальное состояние",
    HumanExistence: "Переключатель наличия человека",
    heartRateMonitoring: "Включение/выключение мониторинга пульса",
    respiratoryMonitor: "Включение/выключение мониторинга дыхания",
    sleepMonitoring: "Включение/выключение мониторинга сна",
    struggle: "Функция состояния аномальной борьбы",
    RealTimeDataTransmission: "Передача данных в реальном времени",
    SleepStateTransmission: "Передача состояния сна",
    SleepQualityAnalysis: "Анализ качества сна",
    SleepSynthesis: "Сводное состояние сна",
    reportFormMode: "Режим отчёта",
    reportForm: "Отчёт",
    detailInfo: "Подробная информация",
    once: "раз",
    issueSetSeccess: "Режим отчёта успешно установлен",
    changeErr: "Не удалось изменить состояние",
    changeSuc: "Состояние успешно изменено",
}
